import React, { Component } from 'react';
import Alert from 'react-s-alert';
import classNames from 'classnames';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import { renderTextField, renderCheckBox } from '../../../../../../components/reduxFields';
import PaginatorCustom from '../../../../../../components/paginationCustom';
import SortingCustom from '../../../../../../components/SortingCustom';
import {change, Field, reduxForm, reset } from 'redux-form';
import { resetFiltersAndSorting, alertConfirmation } from '../../../../../../actions/utilAction';
import { deleteLocations, getLocationsList } from './actions/locationsActions';
import SubString from 'add-ellipsis';
import Tooltip from '../../../../../../components/Tooltip';
import LocationsModal from './locations_Modal';
import { UpdateDCArchiveStatus } from '../../../../../MastersDataCollection/curriculumLibraries/actions/CurriculumLibrariesActions';
import { CommonButton } from '../../../../../../components/buttons';

const stylescss = {
  checkbox: {
    marginBottom: 16,
  },
};


class Locations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      locationsId: null,
      locationsObj: null,
      patientId: props.patientId,
      selectedReductionsIds: [],     
      ShowArchivedOnly : false,   
    };

    this.filter = {
      sort_Column: 'id',
      sort_order: 'desc',
      searchText: '',
    };

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.renderBehavior = this.renderBehavior.bind(this);
    this.handleAlertClick = this.handleAlertClick.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSubmitSearch = this.handleSubmitSearch.bind(this);
    this.handleResetButton = this.handleResetButton.bind(this);
    this.CheckReduction = this.CheckReduction.bind(this);
    this.ResetAllCheckBoxes = this.ResetAllCheckBoxes.bind(this);
  }

  componentWillMount() {
    this.loadData();
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.deleted_locations && nextProps.deleted_locations !== this.props.deleted_locations) {
      this.loadData();
    }
    if (nextProps.saved_locations && nextProps.saved_locations !== this.props.saved_locations) {
      this.loadData();
    }

    if (nextProps.archiveBatchDCStatus && nextProps.archiveBatchDCStatus !== this.props.archiveBatchDCStatus) {
      this.setState({ selectedReductionsIds : [] },()=>{
        this.ResetAllCheckBoxes();
        this.loadData();
      });      
    }  
  }
  loadData(page_number) {
    let searchObj = {
      sort_fields: this.filter.sort_Column || 'id',
      sort_order: this.filter.sort_order || 'desc',
      contain_filters: { searchText: this.filter.searchText || null, patientId: this.state.patientId || null, ShowArchivedOnly: this.state.ShowArchivedOnly ? '1' : '0', },
      pageNumber: page_number ? page_number : 1,
    };
    this.props.getLocationsList(searchObj, this.props.patientId);
  }


  handleOpen() {
    Alert.closeAll();
    this.setState({ open: true, locationsId: null, locationsObj: null });
  }
  handleClose() {
    this.setState({ open: false });
  };

  handleEditClick = (e, obj) => {
    Alert.closeAll();
    this.setState({
      open: true,
      locationsId: obj.id,
      locationsObj: obj,
    });
  };

  handleAlertClick = (event, Id) => {
    Alert.closeAll();
    this.props.deleteLocations(Id);
  };

  handleDeleteClick = (e, obj) => {
    let warningMsg = `Are you sure you want to delete this location?`;
    alertConfirmation(warningMsg, {
      html: true,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick,
        id: obj.id,
      },
    });
  };

  setSortColumn(col_name, col_order) {
    this.filter.sort_Column = col_name;
    this.filter.sort_order = col_order;
    this.loadData();
  }

  componentWillUnmount() {
    Alert.closeAll();
  }

  handleSearchChange(event) {
    if (event.target.value.length > 2) {
      this.filter.searchText = event.target.value;
      this.loadData();
    } else if (event.target.value.length === 0) {
      this.filter.searchText = '';
      this.loadData();
    }
  }
  handleResetButton() {
    Alert.closeAll();
    this.props.dispatch(reset('LocationsForm'));
    resetFiltersAndSorting(this.filter, 'id', true);
    this.setState({ ShowArchivedOnly : false  }, ()=>{this.loadData();});
  }

  ResetAllCheckBoxes()
  {
    this.props.LocationsListData != null && this.props.LocationsListData && this.props.LocationsListData.data.forEach((obj, Index) => {
        let idCheck = `Claims[${Index}].Chk`;                
        this.props.dispatch(change('LocationsForm', idCheck, false));                
    });
  }

  CheckReduction(e, index, data) {    
    let selectedReductionsIds = this.state.selectedReductionsIds;        
    let isChecked = e.target.checked;
    if (isChecked) {     
      selectedReductionsIds.push(data.id);              
    } else {     
        index = selectedReductionsIds.findIndex((value) => value === data.id);
        if (index >= 0) {
          selectedReductionsIds.splice(index, 1);         
        }      
    }
    this.setState({ selectedReductionsIds });
  }

  handleAdvanceFilterCheck = (input, name) => {
    this.setState({ [name]: input.target.checked },
      () => {
        this.loadData();
      });
  }

  handleAlertArchiveBatchReductionsClick = (event) => {
    this.props.UpdateDCArchiveStatus(this.state.selectedReductionsIds.toString(), true, 'LocationsReduction');
    Alert.closeAll();
  }

  handleArchiveBatchReductionsClick = (event) => {
    Alert.warning('Are you sure you want to archive selected location reduction(s)?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertArchiveBatchReductionsClick,
        //id: obj.id,
      },
    });
  }

  handleAlertUnArchiveBatchReductionsClick = (event) => {
    this.props.UpdateDCArchiveStatus(this.state.selectedReductionsIds.toString(), false, 'LocationsReduction');
    Alert.closeAll();
  }

  handleUnArchiveBatchReductionsClick = (event) => {
    Alert.warning('Are you sure you want to unarchive selected location reduction(s)?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertUnArchiveBatchReductionsClick,
        //id: obj.id,
      },
    });
  }


  handleSubmitSearch() {
    return false;
  }

  renderBehavior = (LocationsList) => {
    LocationsList = LocationsList || [];

    if (!LocationsList.length) {
      return (
        <tr>
          <td colSpan="4">
            <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
          </td>
        </tr>
      );
    }
    return LocationsList.map((data, index) => {
      return (
        <tr key={index}>
          <td width="5%">
              <div className="table_custom-check">
              <Field
                  name={`Claims[${index}].Chk`}
                  component={renderCheckBox}
                  onChange={(e) => this.CheckReduction(e, index, data)}
                  style={stylescss.checkbox}
              />
              </div>
          </td>
          <td>{data.locationName}</td>
          <td>
              {data.description && data.description.length > 0 ?
              <Tooltip Description={data.description} />
              : null}
              {data.description != null && data.description.length > 50 ? SubString(data.description, 50) : data.description != null ? data.description : 'N/A'}
          </td>     
          {this.props.updatePermission || this.props.deletePermission ?
            <td>
              {this.props.updatePermission ?
                <button onClick={(e) => this.handleEditClick(e, data)} title="Edit" type="button" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                : null}
              {this.props.deletePermission ?
                <button onClick={(e) => this.handleDeleteClick(e, data)} title="Delete" type="button" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                : null}
            </td>
            : null}
        </tr>
      );
    });
  };

  render() {
    const { handleSubmit, LocationsListData } = this.props,
      LocationsList = (LocationsListData && LocationsListData.data) || [],
      locationsMeta = (LocationsListData && LocationsListData.meta) || null;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.bordered,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'customtable': true,
      'suptable': true,
    });
    return (
      <div>
        {this.state.open ?
          <LocationsModal
            open={this.state.open}
            patientId={this.state.patientId}
            closeDialog={this.handleClose}
            locationsId={this.state.locationsId}
            locationsObj={this.state.locationsObj}
          /> : ''}
        <div className="row mt-3">
          <div className="col-sm-3">
            {this.props.addPermission ?
              <RaisedButton label="Add New Location" primary={true} onTouchTap={this.handleOpen} />
              : null}
          </div>
          <div className="col-sm-3">
                <CommonButton className={this.state.selectedReductionsIds.length > 0 ? "soapmodal_btn ml_15" : "grey_btn ml_15 reset-disable"}  primary={true} disabled={this.state.selectedReductionsIds.length > 0 && !this.state.ShowArchivedOnly ? false : true} label="Mark as Archived" onTouchTap={(e) => this.handleArchiveBatchReductionsClick(e)} />
            </div>
            <div className="col-sm-3">
                <CommonButton className={this.state.selectedReductionsIds.length > 0 ? "soapmodal_btn ml_15" : "grey_btn ml_15 reset-disable"}  primary={true} disabled={this.state.selectedReductionsIds.length > 0 && this.state.ShowArchivedOnly ? false : true}  label="Mark as Unarchived" onTouchTap={(e) => this.handleUnArchiveBatchReductionsClick(e)} />
            </div>
            <div className="col-sm-3 field-mr">
                <Field
                name="ShowArchivedOnly"
                label="Show Archived Only"
                component={renderCheckBox}
                onChange={(e) => this.handleAdvanceFilterCheck(e, 'ShowArchivedOnly')}
                />
            </div>  
            <div className="col-sm-3 mt-20">
            <div className="row end-flex">
              <div className="col-sm-6 mtm-27">
                <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSubmitSearch)}>
                  <Field
                    name="Name"
                    floatingLabelText="Search"
                    maxLength="10"
                    onChange={this.handleSearchChange}
                    component={renderTextField}
                    fullWidth={true}
                  />
                </form>
              </div>
              <div className="reset-btn col-sm-3">
                <RaisedButton className="grey_btn" onTouchTap={this.handleResetButton} >Reset</RaisedButton>
              </div>
            </div>
          </div>
        </div>

        <div className="table-responsive mt-15">
          <table className={tableClass}>
            <thead>
              <tr>
              <th width="5%"></th>
                <th width="25%">
                  {<SortingCustom noSort={!LocationsList.length} setSortColumn={this.setSortColumn} columnName='name' displayName='Location Name' />}
                </th>
                <th width="50%">Definition</th>
                {this.props.updatePermission || this.props.deletePermission ?
                  <th width="20%">Actions</th>
                  : null
                }
              </tr>
            </thead>
            <tbody>
              {this.renderBehavior(LocationsList)}
            </tbody>
          </table>
        </div>
        {locationsMeta && locationsMeta['totalPages'] ?
          <PaginatorCustom data={locationsMeta} handlePageChange={(page_number) => this.loadData(page_number)} />
          : null
        }
      </div>
    );
  }
}

Locations = reduxForm({
  form: 'LocationsForm',
})(Locations);

function mapStateToProps(state) {

  // Start For Role Permission
  let userActionPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === "CLIENT");
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === "CLIENT_DATACOLLECTION_SETUP" && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_ADD_LOCATIONS")[0].permission : false;
  let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_UPDATE_LOCATIONS")[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_DELETE_LOCATIONS")[0].permission : false;

  // End For Role Permission
  return {
    loading: state.patient_locations.loading,
    LocationsListData: state.patient_locations.LocationsList,
    deleted_locations: state.patient_locations.deleted_locations,
    saved_locations: state.patient_locations.saved_locations,
    addPermission: addPermission, // For Role Permission
    updatePermission: updatePermission, // For Role Permission
    deletePermission: deletePermission, // For Role Permission
    archiveBatchDCStatus: state.curriculumLibraries.archiveBatchDCStatus,   
  };
}

export default connect(mapStateToProps, { deleteLocations, getLocationsList, UpdateDCArchiveStatus })(Locations);




// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/BehaviorReductiom/Locations/index.js